import { getArticleUrl } from '@utils/getters';
import { ArticleViewType, ProcessedArticleI } from 'types/article';

export const getFBPixelEventProperties = (lang: string, article: ProcessedArticleI, viewType: ArticleViewType) => {
  const category = `${lang}-post-${viewType}-news-view`;
  const customProperties = {
    content_name: 'content-view',
    content_category: category,
    transinfo_title: article.title.replace(/"/g, "'"),
    transinfo_author: `${article.author.firstName} ${article.author.lastName}`,
    transinfo_url: `${process.env.NEXT_PUBLIC_BASE_URL}${getArticleUrl(article)}`,
    transinfo_content_id: article.id,
  };

  return customProperties;
};

export const getGAEventProperties = (lang: string, article: ProcessedArticleI, viewType: ArticleViewType) => {
  const category = `${lang}-post-${viewType}-news-view`;
  const customProperties = {
    transinfo_view_category: category,
    transinfo_title: article.title.replace(/"/g, "'"),
    transinfo_author: `${article.author.firstName} ${article.author.lastName}`,
  };

  return customProperties;
};
